import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';

import SignedInLinks from './SignedInLinks';
import SignedOutLinks from './SignedOutLinks';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

const MenuBar = (props) => {
	const { auth, profile, userRoleAdmin } = props;
	const links = auth.uid ? (
		<SignedInLinks profile={profile} userRoleAdmin={userRoleAdmin} />
	) : (
		<SignedOutLinks />
	);

	return (
		<Navbar
			collapseOnSelect
			expand='lg'
			variant='dark'
			fixed='top'
			className='bg-navbar-web header-background'>
			<Container>
				<LinkContainer to='/' className='nav-btn mr-3'>
					<strong className='brand-name'>Majo Cobos</strong>
				</LinkContainer>
				<Navbar.Toggle aria-controls='responsive-navbar-nav' />
				<Navbar.Collapse
					id='responsive-navbar-nav'
					className='justify-content-center'>
					{links}
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
};

const mapStateToProps = (state) => {
	const { auth, profile } = state.firebase;

	return {
		auth,
		profile,
	};
};

export default connect(mapStateToProps)(MenuBar);
